import { render, staticRenderFns } from "./projects_detailed.vue?vue&type=template&id=75888062&"
import script from "./projects_detailed.vue?vue&type=script&lang=js&"
export * from "./projects_detailed.vue?vue&type=script&lang=js&"
import style0 from "./projects_detailed.vue?vue&type=style&index=0&id=75888062&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports